<template>
  <v-data-table
    v-model="value.selected"
    :items="value.items"
    :headers="headers"
    :options.sync="value.options"
    :loading="value.loading"
    item-key="id"
    class="elevation-0"
  >
    <template v-slot:item.day="{ item }">
      {{ dateFormatting(item.day) || missingValueString }}
    </template>

    <template v-slot:item.jsonLink="{ item }">
      <div class="d-flex align-center">
        <template v-if="item.xlsxLink || item.jsonLink">
          <a
            v-if="item.xlsxLink"
            :href="`${baseUrl}${item.xlsxLink}`"
            @click.prevent="fileDownload($event, item, 'XLSX')"
          >
            xlsx
          </a>
          <a
            v-if="item.jsonLink"
            :href="`${baseUrl}${item.jsonLink}`"
            @click.prevent="fileDownload($event, item, 'JSON')"
            class="ml-3"
          >
            json
          </a>
        </template>
        <template v-else>
          {{ item.errorMessage }}
        </template>
      </div>
    </template>
  </v-data-table>
</template>

<script>
import { mapActions } from 'vuex';
import requestUrlFunction from '@/utils/requestUrl';
import { downloadFile } from '@/components/mixins/downloadFile';

export default {
  name: 'TablePlannedOutage',
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return [];
      },
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [downloadFile],
  data() {
    return {
      headers: [
        {
          text: 'Datum generováni',
          value: 'day',
          width: '90px',
        },
        {
          text: 'Soubory ke stažení',
          value: 'jsonLink',
          width: '200px',
        },
      ],
      baseUrl: process.env.VUE_APP_BACKEND,
    };
  },
  methods: {
    ...mapActions({
      getPlannedOutageExport: 'installations/getPlannedOutageExport',
    }),
    fileDownload(event, item, fileFormat) {
      const searchParams = {
        filterParams: {
          reportCreated: item.day,
          reportFileFormat: fileFormat,
        },
      };
      this.downloadFile(event, `installations/planned-outage/export/${requestUrlFunction(searchParams)}`);
    },
  },
  watch: {
    'value.options': {
      handler(options) {
        this.$store.commit('settings/TABLE_ITEMS_UPDATE', {
          tableName: 'plannedOutageList',
          itemsPerPage: options.itemsPerPage,
        });
        this.$emit('onChangeOptions', this.value);
      },
    },
  },
};
</script>
